export default __webpack_public_path__ + "static/media/img5.d6396f15.png";